/* eslint-disable */

// Moving this earlier
import "shared/imports/subscriptions.js"

// library css files
import "app/static/css/bootstrap_custom_new_2.css"
import "app/static/stylus/base_css_new_3.styl"
import "app/static/font-awesome/css/font-awesome.css"

// quorums
import "app/static/stylus/stats_new.styl"
import "app/static/css/select2.css"

import "app/static/css/sweetalert.css"

// quorum stylus files
import "app/static/stylus/modal_css_5.styl"
import "app/static/stylus/LoadingSpinner.styl"
import "app/static/stylus/loading_new.styl"
import "app/static/stylus/ui_STYLUS.styl"
import "app/static/stylus/note_modal.styl"
import "app/static/stylus/attachments.styl"
import "app/static/stylus/search.styl"
import "app/static/stylus/filters.styl"

import "codemirror/theme/monokai.css"
import "codemirror/lib/codemirror.css"
import "codemirror"

// djangio
import "shared/djangio/initialize"
import "shared/djangio/config"
import "imports/backenderror.js"

import "components/LoadingSpinner"

import axios from "axios"

// quorum react scripts
import ReactDOM from "react-dom"
import React from "react"

import { Provider, connect } from "react-redux"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import withRouter from "app/static/frontend/routing/withRouter"
import { createStore, applyMiddleware, compose } from "redux"
import thunk from "redux-thunk"

import previousPathnameMiddleware from "app/static/frontend/middleware/previousPathnameMiddleware"
import segueMiddleware from "app/static/frontend/middleware/segueMiddleware"

import { handle205 } from "imports/desktopHelperFunctions"

const composeWithDevTool = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const middlewares = [thunk, previousPathnameMiddleware, segueMiddleware]

import dashboardsReducer from "dashboards/reducer"
import routingReducer from "app/static/frontend/routing-reducer"
import stanceReducer from "shared/stance/reducer"
import { combineReducers } from "redux"
import { getStanceCustomLabelsForExternalDashboard } from "shared/stance/action-creators"

// Initialize Sentry SDK
import { initSentry } from "app/static/frontend/sentry"
initSentry({
    // quorum-production project (TODO: rename to Quorum Frontend)
    dsn: "https://848ffd2604c945be8f19c9ebe0853159@o19956.ingest.us.sentry.io/39808"
})

const reducer = combineReducers({
    routing: routingReducer,
    dashboards: dashboardsReducer,
    stance: stanceReducer,
})

// Set Axios to handle a 205 Reset Content correctly.
axios.interceptors.response.use(handle205)

// create the global state from these functions
const store = createStore(reducer, composeWithDevTool(applyMiddleware(...middlewares)))

// THIE IS BAD PRACTICE but a good transition step so that its exposed to legacy code
window.store = store

window.moment = require("moment")

import Dashboard from "dashboards/containers/Dashboard"
import getExternalPasswordWrapper from "app/static/frontend/components/ExternalPasswordWrapper"

// --------- BEGIN legacy imports ---------- //
// This section is important to maintain our legacy pages that still rely on global
// imports. This is bad practice in the long run, but as we rewrite the old pages,
// we will require fewer of these ugly global imports
global.$ = global.jQuery = require("jquery")
window.$ = global.$
window.QueryString = require("imports/querystring.js")

const d3 = require("../js/libs/d3.min.js")
const d3Queue = require("../js/libs/queue.v1.min.js")
d3.queue = d3Queue
window.d3 = d3
global.d3 = d3

require("../js/libs/d3.tip.js")
// --------- END legacy imports ---------- //

// For certain entry points in our application (like Public
// Sheets and other public facing bundles), we need to use our Selects,
// but must explicitly exclude Search and Searchify from the application's
// dependency graph. Search includes in its dependency graph whole sets of
// functionality that will not work without globally scoped variables and
// resources like Userdata or D3, as well as bloats the bundle size dramatically.
// This entry point spoofs the Searchify behavior in our Select library, and allows
// us to use our abstracted Selects without search.
import SearchifyWrapper from "app/static/frontend/search-new/components/Searchify/SearchifyWrapperDummy"
window.SearchifyWrapper = SearchifyWrapper

const ExternalDashboardWrapper = connect(null, {
    getStanceCustomLabelsForExternalDashboard,
})(getExternalPasswordWrapper("dashboardId", Dashboard, ["getStanceCustomLabelsForExternalDashboard"]))

const QuorumRouter = (
    <Provider store={store}>
        <BrowserRouter>
            <Routes>
                <Route path="/dashboard/external/:dashboardId/" Component={withRouter(ExternalDashboardWrapper)} />
            </Routes>
        </BrowserRouter>
    </Provider>
)

ReactDOM.render(QuorumRouter, document.getElementById("external-dashboard"))
